document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-menu-toggle]');
  if (!button) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const open = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!open));
  nav.hidden = open;
  document.body.classList.toggle('menu-open', !open);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  const button = document.querySelector('[data-add-to-cart]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.availableLabel : button.dataset.soldOutLabel;
  }
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-booking-load]');
  if (!button) return;
  const module = button.closest('.booking-module');
  const frame = module && module.querySelector('[data-booking-frame]');
  const launch = module && module.querySelector('[data-booking-launch]');
  if (!frame) return;
  if (!frame.src) frame.src = frame.dataset.src;
  frame.hidden = false;
  if (launch) launch.hidden = true;
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-mobile-nav] a')) return;
  const menu = document.querySelector('[data-mobile-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (menu) menu.hidden = true;
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
});
document.addEventListener('keydown', (event) => {
  const menu = document.querySelector('[data-mobile-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (event.key === 'Escape' && menu && !menu.hidden) {
    menu.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    toggle?.focus();
  }
});
